import { ResponseCode } from './request-response';

export enum SortDirectionFinancing {
    /** 0 */
    UNKNOWN_SORT_DIRECTION = 'UNKNOWN_SORT_DIRECTION',
    /** 1 */
    ASCENDING = 'ASCENDING',
    /** 2 */
    DESCENDING = 'DESCENDING'
}

export class Pagination {
    public skip?: number;
    public take?: number;
    public sortColumn?: string;
    public sortDirection?: SortDirectionFinancing;
    public secondarySortColumn?: string;
    public secondarySortDirection?: SortDirectionFinancing;
    public tertiarySortColumn?: string;
    public tertiarySortDirection?: SortDirectionFinancing;
    constructor(obj?: {
        skip?: number;
        take?: number;
        sortColumn?: string;
        sortDirection?: SortDirectionFinancing;
        secondarySortColumn?: string;
        secondarySortDirection?: SortDirectionFinancing;
        tertiarySortColumn?: string;
        tertiarySortDirection?: SortDirectionFinancing;
    }) {
        if (obj != null) {
            this.skip = typeof obj.skip === 'undefined' ? this.skip : obj.skip;
            this.take = typeof obj.take === 'undefined' ? this.take : obj.take;
            this.sortColumn =
                typeof obj.sortColumn === 'undefined' ? this.sortColumn : obj.sortColumn;
            this.sortDirection =
                typeof obj.sortDirection === 'undefined' ? this.sortDirection : obj.sortDirection;
            this.secondarySortColumn =
                typeof obj.secondarySortColumn === 'undefined'
                    ? this.secondarySortColumn
                    : obj.secondarySortColumn;
            this.secondarySortDirection =
                typeof obj.secondarySortDirection === 'undefined'
                    ? this.secondarySortDirection
                    : obj.secondarySortDirection;
            this.tertiarySortColumn =
                typeof obj.tertiarySortColumn === 'undefined'
                    ? this.tertiarySortColumn
                    : obj.tertiarySortColumn;
            this.tertiarySortDirection =
                typeof obj.tertiarySortDirection === 'undefined'
                    ? this.tertiarySortDirection
                    : obj.tertiarySortDirection;
        }
    }
}

export class ProtoRequest {}

export class ProtoListRequest extends ProtoRequest {
    public pagination: Pagination;
}

export class ProtoResponse<RowType = any> {
    public ok: boolean = null;
    public pagination?: Pagination;
    public totalCount?: number;
    public rows?: RowType[];
}

export class Mk2Request {}

export class Mk2ListRequest extends Mk2Request {
    public pagination?: any;
}

export class Mk2Response<RowType = any> {
    public ok?: boolean = null;
    public code?: ResponseCode = null;
    public message?: string = null;
    public pagination?: any;
    public totalCount?: number;
    public rows?: RowType[];
}
